<template>
  <el-form-item
    v-bind="$attrs"
    class="i-form-item"
    :label="label"
  >
    <slot />
  </el-form-item>
</template>

<script>
export default {
  name: 'IFormItem',
  props: {
    label: {
      type: String,
      default: '',
    },
  },
  mounted() {
    const input = this.$el.querySelector('input:not([readonly])');
    const select = this.$el.querySelector('.el-select:not(.placeholder-as-label)');
    const label = this.$el.querySelector('.el-form-item__label');

    const updateHasValueClass = (hasValue) => {
      this.$el.classList.toggle('has-value', hasValue);
    };

    const handleFocus = () => this.$el.classList.add('is-focus');
    const handleBlur = (selectHasValue) => {
      this.$el.classList.remove('is-focus');
      if (input) {
        updateHasValueClass(!!input.value || selectHasValue);
      }
    };

    if (select) {
      const selectedItem = select.querySelector('.el-select__placeholder');

      this.$nextTick(() => {
        const selectedItemValue = selectedItem?.querySelector('span');
        updateHasValueClass(selectedItemValue.textContent || !selectedItem?.classList.contains('is-transparent'));
      });

      input?.addEventListener('focus', handleFocus);

      const selectWrapper = select.querySelector('.el-select__wrapper');

      if (input) {
        input?.addEventListener('blur', () => {
          const selectedItem = select.querySelector('.el-select__placeholder');
          const selectedItemValue = selectedItem?.querySelector('span');
          handleBlur(selectedItemValue.textContent || !selectedItem?.classList.contains('is-transparent'));
          updateHasValueClass(input.value || (input.placeholder && input.placeholder !== this.label));
        });
      }
      selectWrapper.addEventListener('click', handleFocus);
      selectWrapper.addEventListener('focusout', () => {
        const selectedItem = select.querySelector('.el-select__placeholder');
        const selectedItemValue = selectedItem?.querySelector('span');
        handleBlur(selectedItemValue.textContent);
        updateHasValueClass(selectedItemValue.textContent);
      });
    } else if (input) {
      this.$nextTick(() => {
        updateHasValueClass(!!input.value);
      });

      input.addEventListener('focus', handleFocus);
      input.addEventListener('blur', () => {
        handleBlur();
        updateHasValueClass(input.value || (input.placeholder && input.placeholder !== this.label));
      });
      input.addEventListener('input', (e) => {
        updateHasValueClass(!!e.target.value);
      });
    }

    if (label && (input || select)) {
      label.addEventListener('click', () => input.focus());
    }
  },
};
</script>
